var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41659 2.33331C4.16142 2.33331 2.33325 4.16148 2.33325 6.41665C2.33325 8.67181 4.16142 10.5 6.41659 10.5C7.33378 10.5 8.18035 10.1976 8.86202 9.68703L10.9124 11.7374L11.7374 10.9125L9.68698 8.86208C10.1975 8.1804 10.4999 7.33384 10.4999 6.41665C10.4999 4.16148 8.67175 2.33331 6.41659 2.33331ZM3.49992 6.41665C3.49992 4.80582 4.80575 3.49998 6.41659 3.49998C8.02742 3.49998 9.33325 4.80582 9.33325 6.41665C9.33325 8.02748 8.02742 9.33331 6.41659 9.33331C4.80575 9.33331 3.49992 8.02748 3.49992 6.41665Z",
    fill: "#494656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerRightIcon);
export default __webpack_public_path__ + "static/media/ser_right_icon.f855170016ed80fbf5d526fa21edec93.svg";
export { ForwardRef as ReactComponent };